export const en = {
    'link-domain-not-match-main': 'Link does not lead to page on main site',
    'sitelink-descr-allowed-symbols': 'Invalid characters in sitelink description',
    'sitelink-descr-dublicate': 'Sitelink descriptions must differ',
    'sitelink-descr-max-length': 'One sitelink text exceeds the allowed {maxLength} character length',
    'sitelink-descr-no-empty': 'Enter a description of the sitelink',
    'sitelink-descr-not-allowed-symbols': 'Invalid characters in sitelink description',
    'sitelink-href-invalid': 'URL missing or invalid',
    'sitelink-href-length': 'Link exceeds the allowed {maxLength} character length',
    'sitelink-title-empty': 'Sitelink title required',
    'sitelink-title-max-length': 'Sitelink title exceeds the allowed {maxLength} character length',
    'sitelink-title-restricted-chars-in-field':
        'In the sitelink title, you can only use letters from the Latin, Turkish, Russian, Ukrainian, Belarusian or Kazakh alphabets, and punctuation marks other than "!" and "?".',
    'sitelinks-common-title-max-length': 'Link title exceeds the allowed {maxLength} character length',
    'sitelinks-duplicate-errors': 'Link titles may not be the same',
    'sitelinks-first-block-common-title-max-length':
        'Titles for first four sitelinks exceed the allowed {maxLength} character length',
    'sitelinks-need-to-save': 'Finish editing the sitelinks before saving the ad',
    'sitelinks-second-block-common-title-max-length':
        'Titles for four additional sitelinks exceed the allowed {maxLength} character length',
    'sitelinks-unknown-error': 'Unknown error occurred',
    'turbo-page-invalid': 'Turbo page not specified'
};
